import {
  Bike,
  Car,
  Cross,
  HeartPulse,
  Landmark,
  Shield,
  ShieldCheck,
} from "lucide-react";

/**
 * Policy-page shared constants + tiny format helpers extracted from PoliciesPage.jsx during the
 * 08-Feb refactor. Kept UI-agnostic so PolicyCard, PolicyDialog, PremiumCalendarSidebar and the
 * page shell can all import from one place.
 */

export const POLICY_TYPES = [
  { value: "term_life", label: "Term life", icon: ShieldCheck },
  { value: "life_insurance", label: "Life insurance (endowment / LIC-style)", icon: Landmark },
  { value: "health", label: "Health", icon: HeartPulse },
  { value: "accident", label: "Accident", icon: Cross },
  { value: "two_wheeler", label: "2-Wheeler", icon: Bike },
  { value: "four_wheeler", label: "4-Wheeler", icon: Car },
  { value: "other", label: "Other", icon: Shield },
];

// Types where premium-paying-term and maturity-date make sense as extra fields.
// Pure health / motor / accident policies typically don't have a PPT or maturity date.
export const LIFE_LIKE_TYPES = new Set(["term_life", "life_insurance"]);

export const FREQUENCIES = [
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "half_yearly", label: "Half-yearly" },
  { value: "annually", label: "Annually" },
  { value: "single", label: "Single premium" },
];

export const REMINDER_CHANNELS = [
  { value: "email", label: "Email" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "both", label: "Both" },
  { value: "none", label: "None" },
];

export function typeMeta(v) {
  return POLICY_TYPES.find((t) => t.value === v) || POLICY_TYPES[POLICY_TYPES.length - 1];
}

export function freqLabel(v) {
  return FREQUENCIES.find((f) => f.value === v)?.label || v;
}

export function formatINR(n) {
  if (n == null || n === "") return "—";
  return `₹ ${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Number(n))}`;
}

export function daysUntil(iso) {
  if (!iso) return null;
  const target = new Date(`${iso}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
}

export function formatDate(iso) {
  if (!iso) return "—";
  return new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
